import { render, staticRenderFns } from "./storerecord.vue?vue&type=template&id=6725cb90&scoped=true"
import script from "./storerecord.vue?vue&type=script&lang=js"
export * from "./storerecord.vue?vue&type=script&lang=js"
import style0 from "./storerecord.vue?vue&type=style&index=0&id=6725cb90&lang=scss&scoped=true"
import style1 from "./storerecord.vue?vue&type=style&index=1&id=6725cb90&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725cb90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6725cb90')) {
      api.createRecord('6725cb90', component.options)
    } else {
      api.reload('6725cb90', component.options)
    }
    module.hot.accept("./storerecord.vue?vue&type=template&id=6725cb90&scoped=true", function () {
      api.rerender('6725cb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmware/storerecord.vue"
export default component.exports